import { examAdminAiTasks } from "./exam-admin-ai-tasks";
import { examAdminAssetsCenter } from "./exam-admin-assets-center";
import { examAdminAttemptDetail } from "./exam-admin-attempt-detail";
import { examAdminAuditLogs } from "./exam-admin-audit-logs";
import { examAdminAuth } from "./exam-admin-auth";
import { examAdminCustomFieldDefinitions } from "./exam-admin-custom-field-definitions";
import { examAdminDashboard } from "./exam-admin-dashboard";
import { examAdminDockerImages } from "./exam-admin-docker-images";
import { examAdminDockerInstances } from "./exam-admin-docker-instances";
import { examAdminErrorPages } from "./exam-admin-error-pages";
import { examAdminExams } from "./exam-admin-exams";
import { examAdminExecution } from "./exam-admin-execution";
import { examAdminPapers } from "./exam-admin-papers";
import { examAdminQuestionDetail } from "./exam-admin-question-detail";
import { examAdminQuestions } from "./exam-admin-questions";
import { examAdminReview } from "./exam-admin-review";
import { examAdminRolePermissions } from "./exam-admin-role-permissions";
import { examAdminShell } from "./exam-admin-shell";
import { examAdminSystemSettings } from "./exam-admin-system-settings";
import { examAdminUsers } from "./exam-admin-users";

export const examAdminCatalog = {
  shell: examAdminShell,
  dashboard: examAdminDashboard,
  login: examAdminAuth.login,
  changePassword: examAdminAuth.changePassword,
  systemSettings: examAdminSystemSettings,
  users: examAdminUsers,
  assetsCenter: examAdminAssetsCenter,
  customFieldDefinitions: examAdminCustomFieldDefinitions,
  notFoundPage: examAdminErrorPages.notFoundPage,
  accessDenied: examAdminErrorPages.accessDenied,
  runtimeError: examAdminErrorPages.runtimeError,
  rolePermissions: examAdminRolePermissions,
  papers: examAdminPapers,
  questions: examAdminQuestions,
  questionDetail: examAdminQuestionDetail,
  exams: examAdminExams,
  execution: examAdminExecution,
  attemptDetail: examAdminAttemptDetail,
  dockerImages: examAdminDockerImages,
  ...examAdminDockerInstances,
  review: examAdminReview,
  aiTasks: examAdminAiTasks,
  auditLogs: examAdminAuditLogs,
} as const;
